import { Component } from '@angular/core';
import {
    MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

@Component({
    selector: 'app-map-allowed-icaos-dialog-new',
    templateUrl: './map-allowed-icaos-dialog-new.component.html',
    styleUrls: ['./map-allowed-icaos-dialog-new.component.scss'],
})
export class MapAllowedIcaosDialogNewComponent {
    public icaosInput = '';

    constructor(
        public dialogRef: MatDialogRef<MapAllowedIcaosDialogNewComponent>
    ) {}

    public onSaveClick(): void {
        if (this.icaosInput.trim()) {
            this.dialogRef.close(this.icaosInput.trim());
        }
    }

    public onCancelClick(): void {
        this.dialogRef.close();
    }
}
